export class ServiceGroup {
    public id: string = null;
    public name: string = null;
    public sortOrder: number = 0;
    public defaultStatus: boolean = true;
    public status: boolean;
    public loading: boolean;
    public services: any;
}
